const getMailform = () => {
  const $contactForm = $('#contact-form');
  const targetURL = './inquiry/index.php';
  if ($contactForm.length) {
    $.ajax({
      type: 'GET',
      cache: false,
      url: targetURL,
      dataType: 'html',
      timeout: 30000,
    })
    .done((res) => {
      if (!res.match(/<?php/)) {
        const form = $(res).find('#mailform');
        if (form) {
          $contactForm.html(form);
        }
      }
    })
    .fail((res) => {
      console.log('getform connection error');
    });
  }
};
export default getMailform;



// WEBPACK FOOTER //
// ./src/scripts/common/getMailform.js